import {
  AccordionProps,
  Box,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
} from '@mui/material';

import { KeyboardArrowDownIcon } from '../../icons';
import { Typography } from '../Typography';

type SidebarProductItemProps = {
  onChange: AccordionProps['onChange'];
  isExpanded: boolean;
  content: React.ReactNode;
  title: string;
  icon: React.ReactNode;
  hasContent: boolean;
  isActive: boolean;
};

export const SidebarProductItem = ({
  onChange,
  isExpanded,
  content,
  title,
  icon,
  hasContent,
  isActive,
}: SidebarProductItemProps) => {
  if (!hasContent) {
    return null;
  }

  return (
    //Box used to remove artefacts (borders) from Accordion when it has sibling components
    <Box>
      <Accordion onChange={onChange} expanded={isExpanded} square disableGutters>
        <AccordionSummary
          sx={{ pl: 1, pr: 0 }}
          expandIcon={<KeyboardArrowDownIcon sx={{ color: 'text.disabled' }} />}
        >
          <Stack
            direction='row'
            alignItems='center'
            spacing={2}
            color={isActive ? 'primary.main' : 'text.disabled'}
          >
            {icon}
            <Typography
              sx={{
                color: isActive ? 'primary.main' : 'text.secondary',
                fontWeight: isActive ? 700 : 500,
              }}
            >
              {title}
            </Typography>
          </Stack>
        </AccordionSummary>

        <AccordionDetails sx={{ pl: 4, pr: 0, display: 'block' }}>{content}</AccordionDetails>
      </Accordion>
    </Box>
  );
};
